import codes, { type ICountryCodeItem } from 'country-calling-code';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import type { SelectFieldOption } from '@/components/common/SelectField.vue';
import { measurementUnits } from '@/constants/measurements.contants';
import { useFormat } from './format';

export function useForm() {
  const { t } = useI18n();
  const { getFormattedCountryCode } = useFormat();

  const yesNoOptions = computed<SelectFieldOption[]>(() => [
    { value: 'true', label: t('forms.options.yesNoOptions.yes') },
    { value: 'false', label: t('forms.options.yesNoOptions.no') },
  ]);

  const weightUnitsOptions = computed<SelectFieldOption[]>(() => {
    return Object.values(measurementUnits.weight).map((unit) => ({
      value: unit,
      label: t(`forms.options.weightUnits.${unit}`),
    }));
  });

  const lengthUnitsOptions = computed<SelectFieldOption[]>(() => {
    return Object.values(measurementUnits.length).map((unit) => ({
      value: unit,
      label: t(`forms.options.lengthUnits.${unit}`),
    }));
  });

  const callingCodesOptions = computed<SelectFieldOption[]>(() => {
    return codes.map((callingCode: ICountryCodeItem) => {
      return {
        label: `+${callingCode.countryCodes} ${callingCode.country}`,
        value: getFormattedCountryCode(callingCode.countryCodes[0], callingCode.country),
      };
    });
  });

  return {
    yesNoOptions,
    weightUnitsOptions,
    lengthUnitsOptions,
    callingCodesOptions,
  };
}
